"use client";

import * as React from "react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
const milestones = [{
  year: "2018",
  date: "2018-03-15",
  title: "Agency Genesis",
  description: "RPG-Studios founded in Quitman, GA, with a mission to simplify digital presence for small businesses."
}, {
  year: "2019",
  date: "2019-11-20",
  title: "WordPress Excellence",
  description: "Launched our specialized WordPress design and high-performance hosting infrastructure."
}, {
  year: "2021",
  date: "2021-06-10",
  title: "Expansion Phase",
  description: "Integrated SEO optimization and social media growth strategies into our core service suite."
}, {
  year: "2022",
  date: "2022-08-05",
  title: "Relationship Milestone",
  description: "Successfully reached 100+ long-term partnerships, emphasizing growth over simple transactions."
}, {
  year: "2023",
  date: "2023-12-12",
  title: "Content Evolution",
  description: "Deployed advanced content creation and client training programs to empower business owners."
}, {
  year: "2024",
  date: "2024-05-30",
  title: "AI & Data Synergy",
  description: "Implementation of machine learning for predictive SEO and Google Business Profile management."
}, {
  year: "2025",
  date: "2025-01-01",
  title: "Global Connectivity",
  description: "Expanding our digital reach to support international clients with premium, tech-focused solutions."
}];
export default function CorporateMilestones() {
  return <section data-section-id="88617" id="our-growth-milestones" className="w-full dark bg-background py-16 font-sans selection:bg-primary selection:text-primary-foreground">
      <div className="container mx-auto px-4 md:px-8">
        <div className="mb-8 flex flex-col gap-1">
          <h2 className="text-[11.2px] font-serif font-bold uppercase tracking-widest text-primary">
            Our Evolution
          </h2>
          <p className="text-[11.2px] font-sans text-muted-foreground">
            Building relationships and digital success since 2018.
          </p>
        </div>

        <div className="relative border border-border/50 bg-card/30 backdrop-blur-sm">
          <ScrollArea className="w-full whitespace-nowrap">
            <div className="relative flex min-w-full items-center px-12 py-32">
              {}
              <div className="absolute left-0 right-0 top-1/2 z-0 h-px -translate-y-1/2 bg-gradient-to-r from-primary/20 via-primary to-primary/20 shadow-[0_0_15px_rgba(20,255,255,0.3)]" />

              <div className="relative z-10 flex w-full justify-between space-x-32">
                {milestones.map((milestone, i) => <div key={i} data-index={i} className="relative flex flex-col items-center justify-center">
                    <HoverCard openDelay={100} closeDelay={100}>
                      <HoverCardTrigger asChild>
                        <button className="group relative cursor-crosshair bg-background px-3 py-1 outline-none ring-1 ring-primary/30 transition-all hover:ring-primary focus-visible:ring-1 focus-visible:ring-primary">
                          <span className="text-[11.2px] font-mono font-bold text-primary transition-colors group-hover:text-foreground">
                            {milestone.year}
                          </span>
                        </button>
                      </HoverCardTrigger>
                      <HoverCardContent side="top" align="center" sideOffset={16} className="w-72 rounded-none border border-primary/20 bg-card/90 backdrop-blur-md p-4 shadow-2xl">
                        <div className="mb-3 flex items-center justify-between border-b border-primary/10 pb-2">
                          <span className="text-[11.2px] font-serif font-bold text-primary uppercase tracking-wider">
                            {milestone.title}
                          </span>
                          <span className="text-[11.2px] font-mono text-muted-foreground">
                            {milestone.date}
                          </span>
                        </div>
                        <p className="whitespace-normal text-[11.2px] font-sans leading-relaxed text-foreground/90">
                          {milestone.description}
                        </p>
                      </HoverCardContent>
                    </HoverCard>
                  </div>)}
              </div>
            </div>
            <ScrollBar orientation="horizontal" className="rounded-none bg-primary/10" />
          </ScrollArea>
        </div>
      </div>
    </section>;
}